import { ESocketEvents } from '@modules/core/definitions';
import SocketService from '../../../common/services/socket';
import Api from '../../../common/services/api';
import initialiseOrganisation from '../../organisation/actions/initialise';
import initialiseNetwork from '../../network/actions/initialise';
import logout from '../../authentication/actions/logout';
import receiveTimelineMessage from '../../social/actions/receive-message';
import receiveNotification from './receive-notification';
import { CHAT_UPDATE_NOTIFICATIONS } from '../../../common/hooks/use-update-notifications';

export const CORE_INITIALISE = 'core/INITIALISE';

export default (history) => async (dispatch, getState) => {
  const { organisation, network } = getState();

  try {
    // Load global values needed in the dashboard
    const coreData = [
      Api.get('/v1/available-languages'),
      Api.get('/v1/available-translations'),
      Api.get('/v1/phone-numbers'),
    ];

    let redirect;

    // Don't initialise the currently selected organisation when a network is selected
    // The initialise network action will initialise the parent organisation
    // This fixes an issue when users change the network id directly in the URL
    // Also not neccesary when server side rendering
    if (organisation.selected && !network.selected) {
      redirect = await dispatch(initialiseOrganisation(organisation.selected.id));
    }

    if (network.selected !== network.initialised) {
      redirect = await dispatch(initialiseNetwork(network.selected));
    }

    if (typeof redirect === 'string') return history.replace(redirect);

    // Initialise socket connection
    SocketService.initialise()
      .then(() => {
        SocketService.registerEvent(
          'me', ESocketEvents.ACTIVITY_CREATED, (...args) => dispatch(receiveNotification(...args))
        );
        SocketService.registerEvent(
          'me', ESocketEvents.FEED_MESSAGE_CREATED, (...args) => dispatch(receiveTimelineMessage(...args))
        );
        SocketService.registerEvent(
          'me', ESocketEvents.PRIVATE_MESSAGE_CREATED, async () => {
            const { data } = await Api.get(`/v1/organisations/${organisation.selected.id}/notifications/badge`);
            dispatch({
              type: CHAT_UPDATE_NOTIFICATIONS,
              notificationsCount: data.unread_conversations_count,
            });
          }
        );
      });

    // Note: Push notification logic has been moved to usePushNotifications hook
    // which uses react-onesignal and runs after app is fully initialized

    const [{ data: languages }, { data: translations }, { data: dialCodes }] =
      await Promise.all(coreData);

    return dispatch({
      type: CORE_INITIALISE,
      languages,
      translations,
      dialCodes,
    });
  } catch (err) {
    if (err.type === 'whitelabel_access_error') return history.push('/auth/organisations');
    if (err.type === 'auth_error') return dispatch(logout('error=profile'));

    throw err;
  }
};
